<template>
  <div class="chat">
    <ChatMessagesLoading
      v-show="isLoading"
    />
    <ChatMessages
      v-show="!isLoading"
      ref="chatMessages"
      :messages="messages"
    />
    <ChatInput
      @sendMessage="handleSendMessage"
      @sendArchive="handleSendArchive"
      @sendImage="handleSendImage"
      @sendAudio="handleSendAudio"
      @sendControllerBot="handleSendControllerBot"
      @sendUpdateOperator="handleUpdateOperator"
    />
  </div>
</template>

<script>
import ChatMessages from './ChatMessages.vue'
import ChatMessagesLoading from './ChatMessagesLoading.vue'
import ChatInput from './ChatInput.vue'

export default {
  components: {
    ChatMessages,
    ChatMessagesLoading,
    ChatInput
  },
  props: {
    isLoading: {
      type: Boolean,
      required: true
    },
    messages: {
      type: Array,
      required: true
    },
    conversationId: {
      type: [String],
      required: false,
      default: null
    }
  },
  methods: {
    handleSendMessage (text) {
      const message = {
        id: '',
        conversationId: this.conversationId,
        type: 'chat',
        dateMessage: new Date().toISOString(),
        message: text,
        read: false,
        sent: false,
        to: 'Bot'
      }
      this.$emit('sendChatMessage', message)
      this.scrollToBottom()
    },
    handleSendArchive (archive) {
      const message = {
        id: '',
        conversationId: this.conversationId,
        type: 'base64',
        dateMessage: new Date().toISOString(),
        message: archive,
        read: false,
        sent: false,
        to: 'Bot'
      }
      this.$emit('sendChatMessage', message)
      this.scrollToBottom()
    },
    handleSendImage (Image) {
      const message = {
        id: '',
        conversationId: this.conversationId,
        type: 'base64',
        dateMessage: new Date().toISOString(),
        message: Image,
        read: false,
        sent: false,
        to: 'Bot'
      }
      this.$emit('sendChatMessage', message)
      this.scrollToBottom()
    },
    handleUpdateOperator (payload) {
      console.log('handleUpdateOperator', payload)
      this.$emit('sendUpdateOperator', payload)
    },
    handleSendAudio (audio) {
      const message = {
        id: '',
        conversationId: this.conversationId,
        type: 'base64',
        dateMessage: new Date().toISOString(),
        message: audio,
        read: false,
        sent: false,
        to: 'Bot'
      }
      this.$emit('sendChatMessage', message)
      this.scrollToBottom()
    },
    handleSendControllerBot (controller) {
      this.$emit('sendBot', controller)
      this.scrollToBottom()
    },
    scrollToBottom () {
      if (!this.$refs.chatMessages) return
      this.$refs.chatMessages.scrollToBottom()
    }
  }
}
</script>

<style lang="scss" scoped>
.chat {
  display: flex;
  flex-direction: column;
  min-height: 400px;
  max-width: 1000px;
  flex-grow: 1;
  background-color: #fff;
  border: 1px solid #cfd8dc;
}
</style>



// WEBPACK FOOTER //
// src/views/private/atendimento/components/chat/Chat.vue